// File: TooltipComponent.tsx

import { FC } from "react";
import { TooltipProps } from "@/types/BigDataMap.types";

const TooltipComponent: FC<TooltipProps> = ({ tooltip }) => {
  if (!tooltip) return null;

  return (
    <div
      className={`absolute z-5 bg-popover/80 text-popover-foreground p-1 rounded pointer-events-none text-xs transform -translate-y-full -translate-x-1/2 shadow-md transition-opacity duration-300 ${
        tooltip ? "opacity-100 visible" : "opacity-0 invisible"
      }`}
      style={{
        left: tooltip.x,
        top: tooltip.y,
      }}
    >
      {tooltip.content}
    </div>
  );
};

export default TooltipComponent;
